module.exports = __webpack_public_path__ + "static/img/h24.b962dff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h24.jpg
// module id = gUCn
// module chunks = 0